import { initSentry } from "../../instrument";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import { routeTree } from "../routeTree.gen.ts";
import { App } from "./App.tsx";
import "./styles/main.scss";

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

initSentry(router);

const queryClient = new QueryClient();

type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};

if (import.meta.env.DEV && !window.Telegram?.WebApp?.initData) {
  const mockWebApp: DeepPartial<typeof window.Telegram.WebApp> = {
    initData:
      "chat_instance=-3860123456789098765&chat_type=sender&user=%7B%22allows_write_to_pm%22%3Atrue%2C%22first_name%22%3A%22Max%22%2C%22last_name%22%3A%22VS%22%2C%22id%22%3A715242595%2C%22is_premium%22%3Atrue%2C%22language_code%22%3A%22ru%22%2C%22username%22%3A%22maximvasilevskiy%22%7D&signature=21332&auth_date=1772271250&hash=aedc429491d57624f3e40f540f7ddbbb19ead13790a7cbed901be7ae0d5c10d5",
    disableVerticalSwipes: () => {},
    isExpanded: true,
    expand: () => {},
  };

  window.Telegram = {
    WebApp: mockWebApp as typeof window.Telegram.WebApp,
  };
}

const WebApp = window?.Telegram?.WebApp;
if (WebApp?.disableVerticalSwipes) {
  WebApp.disableVerticalSwipes();
}

const container = document.getElementById("root")!;

const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo?.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
